import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-24 md:py-32 bg-[#f3f0ea]"
        >
            <div className="mx-auto max-w-5xl px-6 md:px-12">
                <div className="max-w-2xl mb-12">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                        <span className="gdc-divider" />
                        Frequently asked
                    </div>
                    <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c]">
                        Everything you might{" "}
                        <span className="italic text-[#114b5f]">wonder</span>.
                    </h2>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    data-testid="faq-accordion"
                    className="w-full space-y-3"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="bg-white rounded-2xl border border-[#e8e4db] px-6"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="text-left font-serif-display text-lg md:text-xl text-[#1a1d1c] hover:no-underline py-6"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[#4a5250] leading-relaxed text-base pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
